import EntityServise from "./entityService";
import http from '../util/ws/wsService'

class VersionService extends EntityServise{
    constructor() {
        super("version")
    }


    async getAll(itemId,page,limit){
        
        return await http.get(this.routeApi,{itemId,page,limit});
    }

    
}

export default new VersionService();